
export var state = function state() {
  return {
    viewUserDetailsList: [],
    moduleSessionCollection: {},
    userCollection: {}
  };
};

export var mutations = {
  setViewUserDetailsList: function setViewUserDetailsList(state, viewUserDetailsList) {
    state.viewUserDetailsList = viewUserDetailsList;
  },
  setViewInfoCollection: function setViewInfoCollection(state, _ref) {
    var usrCollection = _ref.usrCollection,
        msCollection = _ref.msCollection;

    state.moduleSessionCollection = msCollection;
    state.userCollection = usrCollection;
  }
};


//////////////////
// WEBPACK FOOTER
// ./store/viewInfo.js
// module id = ./store/viewInfo.js
// module chunks = 20